module.exports = __webpack_public_path__ + "img/createUser.2c588159.svg";